<template>
  <form>
    <div
      class="row"
      style="
        border-bottom: 2px solid #115E67;
        margin-bottom: 10px;
        font-size: 20px;
        padding: 5px 0px 0px 5px;
        margin-top: 30px;
      "
    >
      <label style="margin: 0px">Ad Accounts</label>
    </div>
    <div style="border: 1px #d4d4d4 solid; padding: 20px; margin-bottom: 20px">
      <div class="form-group row col-md-12">
        <div class="form-group row col-md-12">
          <label class="col-sm-2 col-form-label text-right label-wrapper-style"
            >Profile Brand Name</label
          >
          <label
            v-if="profile.customName"
            class="col-sm-10 pr-5 align-self-center label-value-wrapper-style"
            >{{ profile.customName }}</label
          >
          <label
            v-else
            class="col-sm-10 pr-5 align-self-center label-value-wrapper-style label-not-provided-wrapper"
            >Not Provided</label
          >
        </div>
        <div
          class="form-group row col-md-12"
          v-if="profile.profile_type"
        >
          <label class="col-sm-2 col-form-label text-right label-wrapper-style"
            >Profile Type</label
          >
          <label
            v-if="profile.profile_type"
            class="col-sm-10 pr-5 align-self-center label-value-wrapper-style text-capitalize"
            >{{ profile.profile_type }}</label
          >
          <label
            v-else
            class="col-sm-10 pr-5 align-self-center label-value-wrapper-style label-not-provided-wrapper"
            >Not Provided</label
          >
        </div>
        <!-- <div
          class="form-group row col-md-12"
          v-if="profile.profile_type == 'seller'"
        >
          <label class="col-sm-2 col-form-label text-right label-wrapper-style"
            >Seller</label
          >
          <label
            v-if="profile.merchant_name"
            class="col-sm-10 pr-5 align-self-center label-value-wrapper-style"
          >
            <a
              href="javascript:void(0)"
              @click="viewListPopUp('seller', profile)"
              >{{ profile.merchant_name }}</a
            >
          </label>
          <label
            v-else
            class="col-sm-10 pr-5 align-self-center label-value-wrapper-style label-not-provided-wrapper"
            >Not Provided</label
          >
        </div> -->
        <!-- <div
          class="form-group row col-md-12"
          v-if="profile.profile_type == 'vendor'"
        >
          <label class="col-sm-2 col-form-label text-right label-wrapper-style"
            >Profile Type</label
          >
          <label
            v-if="profile.profile_type == 'vendor'"
            class="col-sm-10 pr-5 align-self-center label-value-wrapper-style"
            >Vendor</label
          >
          <label
            v-else
            class="col-sm-10 pr-5 align-self-center label-value-wrapper-style label-not-provided-wrapper"
            >Not Provided</label
          >
        </div> -->
        <!-- <div
          class="form-group row col-md-12"
          v-if="profile.profile_type == 'vendor'"
        >
          <label class="col-sm-2 col-form-label text-right label-wrapper-style"
            >Vendor</label
          >
          <label
            v-if="profile.vendor_id"
            class="col-sm-10 pr-5 align-self-center label-value-wrapper-style"
          >
            <a
              href="javascript:void(0)"
              @click="viewListPopUp('vendor', profile)"
              >{{ showProfileVendor(profile.vendor_id) }}</a
            >
          </label>
          <label
            v-else
            class="col-sm-10 pr-5 align-self-center label-value-wrapper-style label-not-provided-wrapper"
            >Not Provided</label
          >
        </div> -->
        <div class="form-group row col-md-12">
          <label class="col-sm-2 col-form-label text-right label-wrapper-style"
            >Country</label
          >
          <label
            v-if="profile.country_code"
            class="col-sm-10 pr-5 align-self-center label-value-wrapper-style"
            >{{ profile.country_code }}</label
          >
          <label
            v-else
            class="col-sm-10 pr-5 align-self-center label-value-wrapper-style label-not-provided-wrapper"
            >Not Provided</label
          >
        </div>
        <div class="form-group row col-md-12">
          <label class="col-sm-2 col-form-label text-right label-wrapper-style"
            >Data Pull</label
          >
          <label
            v-if="profile.data_pull"
            class="col-sm-10 pr-5 align-self-center label-value-wrapper-style capital"
            >{{ profile.data_pull }}</label
          >
          <label
            v-else-if = "profile.data_pull == false"
            class="col-sm-10 pr-5 align-self-center label-value-wrapper-style capital"
            >False</label
          >
          <label
            v-else
            class="col-sm-10 pr-5 align-self-center label-value-wrapper-style label-not-provided-wrapper"
            >Not Provided</label
          >
        </div>
        <div class="form-group row col-md-12">
          <label class="col-sm-2 col-form-label text-right label-wrapper-style"
            >Marketing Campaign Type</label
          >
          <label
            v-if="parseData(profile) != ''"
            class="col-sm-10 pr-5 align-self-center label-value-wrapper-style"
            >{{ parseData(profile) }}</label
          >
          <label
            v-else
            class="col-sm-10 pr-5 align-self-center label-value-wrapper-style label-not-provided-wrapper"
            >Not Provided</label
          >
        </div>
        <div class="form-group row col-md-12">
          <label class="col-sm-2 col-form-label text-right label-wrapper-style"
            >Monthly Budget($)</label
          >
          <label
            v-if="profile.monthly_budget"
            class="col-sm-10 pr-5 align-self-center label-value-wrapper-style"
            >{{ profile.monthly_budget }}</label
          >
          <label
            v-else
            class="col-sm-10 pr-5 align-self-center label-value-wrapper-style label-not-provided-wrapper"
            >Not Provided</label
          >
        </div>
        <div class="form-group row col-md-12">
          <label class="col-sm-2 col-form-label text-right label-wrapper-style"
            >Active</label
          >
          <label
            v-if="profile.active"
            class="col-sm-10 pr-5 align-self-center label-value-wrapper-style capital"
            >{{
              profile.active +
              (profile.disable_date
                ? " (Disables on: " +
                  getFormattedDate(profile.disable_date) +
                  ")"
                : "")
            }}</label
          >
          <label
            v-else-if="profile.active == false"
            class="col-sm-10 pr-5 align-self-center label-value-wrapper-style capital"
            >{{
              profile.active +
              (profile.disable_date
                ? " (Disabled on: " +
                  getFormattedDate(profile.disable_date) +
                  ")"
                : "")
            }}</label
          >
          <label
            v-else
            class="col-sm-10 pr-5 align-self-center label-value-wrapper-style label-not-provided-wrapper"
            >Not Provided</label
          >
        </div>
      </div>
    </div>
  </form>
</template>
<script>
import moment from 'moment'
export default {
  data() {
    return {};
  },
  props: ["profile"],
  components:{moment},
  methods: {
    getFormattedDate(date) {
        return  moment(date).format("MM/DD/YYYY");
    },
    parseData(data) {
      let type = [];
      if (data.marketing_campaign_sp == true) {
        type.push("SP");
      }
      if (data.marketing_campaign_sb == true) {
        type.push("SB");
      }
      if (data.marketing_campaign_sd == true) {
        type.push("SD");
      }
      if (data.marketing_campaign_st == true) {
        type.push("ST");
      }

      return type.join(", ");
    },
  },
};
</script>